import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { FormsValidationService } from '../../../../../../shared/services/formsValidation.service';
import { FormatService } from '../../../../../../shared/services/format.service';
import { EvoPatternValidator } from '../../../../../../shared/validators/evo-pattern-validator.directive';
import { EvoToastr } from '../../../../../../shared/services/EvoToastr.service';

@Component({
	selector: 'se-contact-editor-modal',
	styleUrls: ['se-contact-editor.scss'],
	templateUrl: 'se-contact-editor.html',
})
export class SalesEntityContactEditorComponent implements OnInit {
	emailTypes: Array<any> = [];
	phoneTypes: Array<any> = [];
	contactEntity: any = {};
	form: FormGroup = new FormGroup({});
	formPhone: FormArray = new FormArray([]);
	formEmail: FormArray = new FormArray([]);
	isEdit: boolean;
	isView = false;
	notificationSubscribedEmails: Array<string> = [];

	get ModalTitle() {
		return this.isEdit ? 'Contact Edit' : 'Contact Add';
	}

	get ButtonTitle() {
		return this.isEdit ? 'Ok' : 'Add';
	}

	constructor(private activeModal: NgbActiveModal, private formSvc: FormsValidationService, private toastSvc: EvoToastr) {}

	ngOnInit(): void {
		this.CreateForm();
	}

	CreateForm() {
		this.contactEntity = this.contactEntity || {};
		this.contactEntity.ContactEmails = this.contactEntity.ContactEmails || [];
		this.contactEntity.ContactPhones = this.contactEntity.ContactPhones || [];

		if (this.contactEntity.ContactEmails.length === 0) {
			this.contactEntity.ContactEmails.push({
				EmailTypeName: '',
				EmailAddress: '',
				ContactId: 0,
				ContactEmailId: 0,
			});
		}

		if (this.contactEntity.ContactPhones.length === 0) {
			this.contactEntity.ContactPhones.push({
				PhoneTypeName: '',
				PhoneNumber: '',
				ContactId: 0,
				ContactPhoneId: 0,
			});
		}

		this.form.addControl('FirstName', new FormControl(this.contactEntity.FirstName, [Validators.required]));
		this.form.addControl('LastName', new FormControl(this.contactEntity.LastName, [Validators.required]));
		this.form.addControl('ContactEmails', this.formEmail);
		this.form.addControl('ContactPhones', this.formPhone);

		this.contactEntity.ContactEmails.forEach((p) => {
			this.formEmail.push(
				new FormGroup({
					EmailTypeName: new FormControl(p.EmailTypeName, [Validators.required]),
					EmailAddress: new FormControl(p.EmailAddress, [
						Validators.required,
						EvoPatternValidator(this.formSvc.EmailRegex, this.formSvc.EmailRegexMsg),
					]),
					ContactEmailId: new FormControl(p.ContactEmailId, []),
					ContactId: new FormControl(p.ContactId, []),
				})
			);
		});
		this.contactEntity.ContactPhones.forEach((p) => {
			this.formPhone.push(
				new FormGroup({
					PhoneTypeName: new FormControl(p.PhoneTypeName, [Validators.required]),
					PhoneNumber: new FormControl(p.PhoneNumber, [
						Validators.required,
						EvoPatternValidator(this.formSvc.PhoneRegex, this.formSvc.PhoneRegexMsg),
					]),
					ContactPhoneId: new FormControl(p.ContactPhoneId, []),
					ContactId: new FormControl(p.ContactId, []),
				})
			);
		});

		if (this.isView) {
			this.form.disable();
		}
	}

	GetForm() {
		this.contactEntity.FirstName = this.form.controls.FirstName.value;
		this.contactEntity.LastName = this.form.controls.LastName.value;

		const formValue = this.form.getRawValue();

		for (const contactEmail of formValue.ContactEmails) {
			if (contactEmail.ContactEmailId === undefined || contactEmail.ContactEmailId == null) {
				contactEmail.ContactEmailId = 0;
			}
		}

		for (const contactPhone of formValue.ContactPhones) {
			if (contactPhone.ContactPhoneId === undefined || contactPhone.ContactPhoneId == null) {
				contactPhone.ContactPhoneId = 0;
			}
		}

		this.contactEntity.ContactEmails = formValue.ContactEmails;
		this.contactEntity.ContactPhones = formValue.ContactPhones;
	}

	onOk() {
		this.form.markAllAsTouched();
		if (this.form.valid) {
			this.GetForm();
			this.activeModal.close(this.contactEntity);
		}
	}

	onCancel() {
		this.activeModal.close(null);
	}

	addPhone() {
		this.formPhone.push(
			new FormGroup({
				PhoneTypeName: new FormControl('', [Validators.required]),
				PhoneNumber: new FormControl('', [
					Validators.required,
					EvoPatternValidator(this.formSvc.PhoneRegex, this.formSvc.PhoneRegexMsg),
				]),
				ContactId: new FormControl(this.contactEntity.ContactId, []),
			})
		);
	}

	removePhone(idx: number) {
		if (this.formPhone.controls.length === 1) {
			this.toastSvc.toastFailure('Error', 'There must be at least one Phone!');
		} else {
			this.formPhone.removeAt(idx);
			this.form.markAsDirty();
		}
	}

	addEmail() {
		this.formEmail.push(
			new FormGroup({
				EmailTypeName: new FormControl('', [Validators.required]),
				EmailAddress: new FormControl('', [
					Validators.required,
					EvoPatternValidator(this.formSvc.EmailRegex, this.formSvc.EmailRegexMsg),
				]),
				ContactId: new FormControl(this.contactEntity.ContactId, []),
			})
		);
	}

	removeEmail(idx: number) {
		if (this.formEmail.controls.length === 1) {
			this.toastSvc.toastFailure('Error', 'There must be at least one Email!');
		} else {
			// see if the email has subscriptions
			if (this.notificationSubscribedEmails.includes(this.formEmail.controls[idx].value.EmailAddress)) {
				// show confirm dialog
				const confirm = window.confirm('The notification subscriptions of the email you deleted will also be unsubscribed!');
				if (confirm) {
					this.formEmail.removeAt(idx);
					this.form.markAsDirty();
				}
			} else {
				this.formEmail.removeAt(idx);
				this.form.markAsDirty();
			}
		}
	}
}
